import { FC } from 'react';

const FormErrors: FC<{ errors: Record<string, string> }> = ({ errors }) => {
  return (
    <div className='px-4 py-3 bg-risk-light text-risk-dark'>
      <p className='mb-1 text-base font-bold leading-tight text-risk-dark'>
        There&apos;s a problem.
      </p>
      <ul className='space-y-1'>
        {Object.keys(errors).map((error, index) => {
          return <li key={index}>{errors[error]}</li>;
        })}
      </ul>
    </div>
  );
};

export { FormErrors };
